
/**
 * Points Of Interest List
 */
const pois = []
const publicProducts = []
const products = []
const map = {}
const cacheLimiteDate = new Date().getTime()
const useChartCache = false
const isLoading = false
const barChartArrecadacao = {}
const barChartProdutividade = {}
const barChartHorario = {}
const barChartVisitantes = {}
const barChartTamanho = {}
const doughnutChartVisitantes = {}
const barChartRankingVisitantes = {}
const stateYesterdayTotalClients = 0
const stateTomorrowTotalClients = 0
const stateTodayTotalClients = [
  { title: 'confirmados', value: 0 },
  { title: 'checkin', value: 0 },
]
const stateFilteredBillItensAmount = [
  { title: '', value: 0 },
  { title: '', value: 0 },
]

export default {
    pois,
    publicProducts,
    products,
    map,
    isLoading,
    cacheLimiteDate,
    useChartCache,
    barChartArrecadacao,
    barChartProdutividade,
    barChartHorario,
    barChartVisitantes,
    barChartTamanho,
    doughnutChartVisitantes,
    barChartRankingVisitantes,
    stateYesterdayTotalClients,
    stateTomorrowTotalClients,
    stateTodayTotalClients,
    stateFilteredBillItensAmount,
}
